<div class="row">
    <div class="col-12 p-0 pl-1 border-bottom headersize" style="font-size:12px;font-weight:600;">
      Select the Subjects Applicable to the Exam
    </div>
  </div>
  <div class="row">
    <div class="col-7">
      <div class="d-flex justify-content-center" style="font-size:12px;font-weight:600;">
        <div class="headersize">Subjects</div>
        <!-- <div class="p-0 label-red">*</div> -->
      </div>
    </div>
    <div class="col-5">
  
    </div>
  </div>
  <div class="row">
    <div class="col-12" style="height: 35vh !important; overflow: auto;">
  <div class="row">
      <div class="col-12" *ngIf="getSubjectlist!=null">
        <div class="row pt-2">
          <div class="col-1">
          </div>
          <div class="col-10">
            <div class="row pl-2" *ngFor="let s of getSubjectlist;let index=index">
              <div class="col-12">
                <div class="form-check p-1">
                  <input type="checkbox" class="form-check-input chkbx-size"
                    
                    [value]="s.Subject_Name" (change)="eventCheck1($event,index)" [checked]="s.checkedflag">
                  <label class="form-check-label">{{s.Subject_Name}}</label>
                </div>
              </div>
            </div>
            <div class="row pt-1">
              <!-- <div class="col-10"><label class="Valid1" *ngIf="error1.isError">{{ error1.errorMessage }}</label></div> -->
            </div>
          </div>
        </div>
      </div>
  
    </div>
    
  
  
  
  </div>
  <div class="col-12 pb-2">
    <div class="row">

      <div class="col-7">
        <div class="d-flex justify-content-center">
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" 
              class="btn btn-sm bl-btn" (click)="Save()">Save</button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button"  class="btn btn-sm bg-light border" (click)="Cancel()">Cancel</button>
          </div>
        </div>
      </div>
      <div class="col-5">

      </div>
    </div>
  </div>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="deletealertpopup">
    <div class="modal-dialog modal-dialog-alert modal-dialog-centered" style="
    width: 350px;
">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
          <button type="button" class="close" 
            style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="Removealertpopup()">
            <span aria-hidden="true">&times;</span></button>
        </div>
       
        <div class="modal-body px-3 py-0">
          <div class="row py-2 mx-2 pt-3">
            <div class="col-12">
              <label>Do you want to remove the subject?</label>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-12">
              <div class="d-flex justify-content-center">
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bl-btn" (click)="Remove()">Yes</button>
                </div>
                <div class="px-1">
                  <button type="button"  class="btn btn-sm bg-light border" (click)="Removealertpopup()">No</button>
                </div>
                
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </div>
  </div>